import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import * as employmentService from '../../api/employmentService';

const useStyles = makeStyles((theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  })
);

/**
 * Root redirects to the user's companies dashboard.
 */
export default function Root() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [redirectTo, setRedirectTo] = useState<string | null>(null);

  // Fetch the user's company data to perform the redirect
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await employmentService.get();

        if (res) {
          setIsLoading(false);
          // if (res.role === 'restricted' || res.role === 'basic') {
          //   setRedirectTo(`/company/${res.company.id}/qrcodemode`);
          // } else {
          setRedirectTo(`/company/${res.company.id}`);
          // }
          // setRedirectTo(`/`);
        }
      } catch (e: any) {
        if (e.status === 404) {
          setIsLoading(false);
          setRedirectTo('/');
        }
      }
    };

    fetch();
  }, []);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  if (isLoading) {
    return (
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return null;
}
